<!--
Autor: Danilo
Observações:
1 - Para colocar mais de uma linha no conteúdo, utilize o Separador "|" (Barra vertical)
Exemplo: "{p}usuario.desUsuario{/p} | {p}usuario.endereco.desEndereco{/p} | {p}usuario.txtDocumento{/p}"

2 - {p} = Propriedade
Exemplo: "{p}usuario.desUsuario{/p}"

3 - {n} = Linha em Negrito
Exemplo: {n}{p}usuario.desUsuario{/p}

4 - {d} = Descrição antes da propriedade
Exemplo: {d}Documento:{/d}{p}usuario.numDocumento{/p}
-->

<template>
  <div class="row timeline">
    <!--TIMELINE-->
    <q-timeline
      responsive
      color="secondary"
      ref="timeLine"
    >
      <div
        class="timeline-titulo"
        v-show="itensConvertidos != null && itensConvertidos != undefined && itensConvertidos != ''"
      >
        {{titulo}}
      </div>
      <div>
        <q-timeline-entry
          :side="setSide(i.sequencia)"
          :icon="icone"
          :subtitle="i.sequencia"
          :class="setCorpo(setSide(i.sequencia))"
          :color="setCor(setSide(i.sequencia))"
          v-for="i in itensConvertidos"
          v-bind:key="i.a"
        >

          <div
            v-for="c in i.arrayConteudo"
            v-bind:key="c.a"
          >
            <strong v-if="c.negrito">
              {{c.conteudo}}
            </strong>
            <span v-else>
              {{c.conteudo}}
            </span>
          </div>
        </q-timeline-entry>
      </div>
    </q-timeline>
  </div>
</template>

<script>
import util from 'components/util/util'

export default {
  name: 'g-timeLine',
  props: {
    // Representa o objeto referenciado por v-model
    value: {
      type: [String, Number, Array],
      default: ''
    },
    itens: {
      type: Array,
      default: function () { return [] }
    },
    cor: {
      type: String,
      default: ''
    },
    titulo: {
      type: String,
      default: ''
    },

    conteudo: {
      type: String,
      default: ''
    },
    arrayConteudo: {
      type: Array,
      default: function () { return [] }
    },
    icone: {
      type: String,
      default: ''
    },
    itemValor: {
      type: [String, Number],
      default: ''
    }
  },
  data () {
    return {
      itensConvertidos: [],
      linhaAtual: '',
      sequencia: ''
    }
  },
  methods: {
    limpar () {
      var self = this
      self.itensConvertidos = []
    },
    setSide (seq) {
      if (seq % 2 !== 0) { return 'left' } else { return 'right' }
    },
    setCorpo (side) {
      if (side === 'left') {
        return 'timeline-corpo-left'
      } else {
        return 'timeline-corpo-right'
      }
    },
    setCor (side) {
      if (side === 'left') {
        return 'teal-9'
      } else {
        return 'teal-5'
      }
    },
    converterItens (valor) {
      var self = this
      self.sequencia = 0
      // Convertendo array para o formato que o componente reconhece
      // ({sequencia: 'valor', arrayConteudo: []})
      valor.forEach(item => {
        self.itensConvertidos.push(
          {
            sequencia: self.strUndefined(self.setSequencia()).toString(),
            arrayConteudo: self.setArrayConteudo(item)
          }
        )
      })
    },
    setArrayConteudo (item) {
      var self = this
      var arrayConvertido = []
      var conteudos = self.strUndefined(self.conteudo).split('|')
      conteudos.forEach(c => {
        arrayConvertido.push({
          negrito: self.setNegrito(c),
          conteudo: self.setConteudo(c, item)
        })
      })
      return arrayConvertido
    },
    setNegrito (c) {
      // continuar daqui
      if (c.includes('{n}')) {
        return true
      } else {
        return false
      }
    },
    setConteudo (c, item) {
      var self = this
      var descricao = ''
      var corpo = ''

      descricao = self.setDescricao(c).toString()
      corpo = c.substring(c.indexOf('{p}') + '{p}'.length, c.indexOf('{/p}'))
      return descricao.concat(' ').concat(util.getItemRecursivo(self.strUndefined(corpo.toString().trim()), item))
    },
    setDescricao (c) {
      if (c.includes('{d}')) {
        var subStr = ''
        subStr = c.substring(c.indexOf('{d}') + '{d}'.length, c.indexOf('{/d}'))
        return subStr
      } else {
        return ''
      }
    },
    setSequencia () {
      var self = this
      self.sequencia = self.sequencia === undefined ? self.sequencia = 0 : self.sequencia
      self.sequencia = (Number(self.sequencia) + 1)
      return self.sequencia
    },
    // Retorna a etiqueta do item selecionado
    itemEtiquetaSelecionado () {
      if (!this.itens) {
        return null
      }
      var lista = this.itens.filter(p => p[this.itemValor] === this.value)
      if (!lista) {
        return null
      }
      // Retornando a etiqueta do item selecionado pelo usuário
      return lista[0][this.itemEtiqueta]
    },
    strUndefined (valor) {
      if (valor !== undefined && valor !== null) {
        return valor
      } else {
        return ''
      }
    }
  },
  watch: {
    itens (valor) {
      if (valor !== '' && valor !== undefined && valor !== null) {
        this.converterItens(valor)
      }
    },
    value (value) {
      this.dValue = value
      this.validar()
    }
  },
  mounted () {
    if (this.itens !== '' && this.itens !== undefined && this.itens != null) {
      this.converterItens(this.itens)
    }
  }
}
</script>
<style>
.timeline {
  font-size: 12px;
}

.timeline-corpo-left {
  margin-bottom: -25px;
  background-color: white;
  line-height: 15px;
  font-size: 11px;
}
.timeline-corpo-left:hover {
  background-color: #d3d3d3;
}

.timeline-corpo-right {
  margin-bottom: -25px;
  background-color: #ececec;
  line-height: 15px;
  font-size: 11px;
}

.timeline-corpo-right:hover {
  background-color: #d3d3d3;
}

.timeline-titulo {
  background: #b2dfdb;
  color: #3f3f3f;
  border-bottom: 2px solid #a3a3a3;
  padding: 6px;
  font-family: "roboto";
  font-size: 13px;
  text-align: center;
  font-weight: 700;
  margin-bottom: 10px;
  border-radius: 5px 5px 0 0;
}

.q-timeline-responsive .q-timeline-entry {
  padding: 3px 0 3px 0;
}

@media screen and (max-width: 991px) {
  .timeline-corpo-left div {
    margin-left: 30px;
  }
  .timeline-corpo-right div {
    margin-left: 30px;
  }
}
</style>
